import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { store } from 'store/store';
import { Provider } from 'react-redux';
import { LocalizationProvider } from 'contexts/LocalizationContext';
import { MIXPANEL_TOKEN } from 'utils/mixpanel';
import mixpanel from 'mixpanel-browser';

mixpanel.init(MIXPANEL_TOKEN, {
  debug: false,
  record_sessions_percent: 0,
  ...(process.env.REACT_APP_MIXPANEL_API_HOST && {
    api_host: process.env.REACT_APP_MIXPANEL_API_HOST,
  }),
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider>
        <App />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
